<template>
  <router-view />
</template>

<style lang="scss">
body {
  height: 100vh;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.el-popper {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.el-popover__title, .el-message-box__title, .el-message-box__message, .el-message__content, .el-select-dropdown__item {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.page-content {
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
}

.center-content {
  display: flex;
  justify-content: center;
}

.el-table tr.warning-row {
  background-color: var(--el-color-warning-light-9) !important;
}

.el-table tr.danger-row {
  background-color: var(--el-color-danger-light-9) !important;
}

.el-table tr.success-row {
  background-color: var(--el-color-success-light-9) !important;
}
</style>